import { baseApi } from "@/Redux/api/baseApi";

const userProfileInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    MyInfo: builder.query({
      query: () => ({
        url: "public/user/me",
        method: "GET",
      }),
    }),

    UserInfo: builder.query({
      query: (userId) => ({
        url: `public/user/get-profile-info/${userId}`,
        method: "GET",
      }),
    }),

    updateProfile: builder.mutation({
      query: (userData, UID) => ({
        url: `public/user/me`,
        method: "PATCH",
        body: userData,
        params: UID,
      }),
    }),
    updateRole: builder.mutation({
      query: (role, UID) => ({
        url: `public/user/updateRole`,
        method: "PATCH",
        body: role,
        params: UID,
      }),
    }),
  }),
});

export const { useMyInfoQuery, useUserInfoQuery, useUpdateProfileMutation, useUpdateRoleMutation } = userProfileInfoApi;
